import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import FormGroup from '../helpers/FormGroup'
import LogoUploader from '../helpers/LogoUploader'

class CompanyDescription extends React.Component {
  constructor(props) {
    super(props)

  }

  render() {
    const values = this.props.data
    const setData = this.props.setData

    return(
      <fieldset className="fieldset">
        <legend className="h2">Company Details</legend>
        <div className="row">
          <div className="col-12">
            <FormGroup
              type="textarea"
              label="Short company description (shown on canaan.com)"
              value={values.description}
              reqired={true}
              onChange={(v) => setData({description: v})}
            />
          </div>
          <div className="col-12">
            <div className="p-sm"><strong>Company logo</strong></div>
            <div className="help-text">We accept all image formats but prefer scalable vector files like .svg, .eps or .ai. If you have more brand assets, please attach them as a .zip.</div>
            <LogoUploader
              uploadUrl={`/onboarding/form/${values.id}/logo_upload`}
              logo={values.logo}
              setData={setData}
            />
            <br />
            <br />
          </div>
          <div className="col-12">
            <div className="p-sm"><strong>Company resources</strong></div>
            <div className="help-text">Already have a page with a downloadable logo or other brand resources? Enter the URL and we'll get them.</div>
            <FormGroup label="Brand Assets URL" value={values.brand_assets_url} onChange={(v) => setData({brand_assets_url: v})} />
          </div>
        </div>
      </fieldset>
    )
  }
}

export default CompanyDescription
